import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UiState {
  isSidebarCollapsed: boolean;
}

const initialState: UiState = {
  isSidebarCollapsed: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.isSidebarCollapsed = action.payload;
    },
  },
});

export const uiActions = uiSlice.actions;
export default uiSlice.reducer;
